/* wizardRules.js — kitchen wizard defaults + step validation + rule-override resolution.
 * Ported from lhc-app.html: kitchenWizard (~46700), validateRoomStep (~43448), the
 * cm→m override semantics (~39200). Dimension fields are mm; rule overrides are metres.
 */

/** The exact default kitchenWizard object (lhc-app.html ~46700–46764). */
export function defaultKitchenWizard() {
  return {
    step: 1,
    design: "horizon",
    shell: "mfc-white",
    doorStyle: "flat",
    front: "flat-white",
    handle: "bar-alu",
    worktop: "carrara",
    plinth: "10-alu",
    roomFloor: "fl-oak",
    roomWall: "wl-white",
    roomCeiling: "ce-white",
    packing: "assembled",
    wallsMode: "manual",
    wallsShape: "straight",
    roomName: "",
    wallThickness: 150,   // mm
    // 2026-07-19: starts at the typical 2700 (was null + placeholder — the
    // field rendered .invalid red before the user touched it, read as a bug).
    wallHeight: 2700,     // mm
    wallUnitHeight: 1500, // mm
    roomWidth: null,      // mm
    roomDepth: null,      // mm
    wallFinish: null,
    ceilingFinish: null,
    rulePlinthH: null,    // m
    ruleCarcassH: null,   // m
    ruleWorktopT: null,   // m
    ruleSplashGap: null,  // m
    finishesLinked: true,
    isEditMode: false,
    priceGroup: "G1",
    worktopRate: null,    // €/m (default 180)
    plinthRate: null,     // €/m (default 35)
    corniceRate: null,    // €/m (default 45)
    quoteManualLines: [],
    quoteVersions: [],
    quoteTaxRate: 0,
    quoteDiscount: 0,
    cornerStyle: "simple",
  };
}

/** validateRoomStep(kw): bounds (mm) — thickness 50–400, height 2000–4500,
 *  wallUnitHeight 1200–2200, name non-empty, both finishes set. (~43448) */
export function validateRoomStep(kw = {}) {
  const shape = !!kw.wallsMode;
  const nameOk = (kw.roomName || "").trim().length > 0;
  const thickOk = Number.isFinite(kw.wallThickness) && kw.wallThickness >= 50 && kw.wallThickness <= 400;
  const heightOk = Number.isFinite(kw.wallHeight) && kw.wallHeight >= 2000 && kw.wallHeight <= 4500;
  const vposOk = Number.isFinite(kw.wallUnitHeight) && kw.wallUnitHeight >= 1200 && kw.wallUnitHeight <= 2200;
  const dims = nameOk && thickOk && heightOk && vposOk;
  const finishes = !!kw.wallFinish && !!kw.ceilingFinish;
  return { shape, dims, finishes, all: shape && dims && finishes, nameOk, thickOk, heightOk, vposOk };
}

/** Convert a cm field value (as edited in Room Settings) to a stored metres override
 *  (or null if not a finite positive number). (~39208) */
export function cmFieldToOverrideM(rawCm) {
  const raw = parseFloat(rawCm);
  return isFinite(raw) && raw > 0 ? raw / 100 : null;
}
